export default "__VITE_ASSET__FUVcQ4HB__"